export default __webpack_public_path__ + "static/accounts-d20934865da196fbcad3f6b35f677653.svg";